import { ENV_VARS } from '@/env';
import { Tabs } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../../../../contants/routes';
import { routeFileSelector } from '../../../../../utilz/i18n';
import SearchQuotePage from '../../../../pages/Shipment/SearchQuotePage';

const TAB_GROUPS = {
  scroll: ['QuoteCollboratorLogs', 'QuoteBiddingLogs'],
  empty: ['bid_history', 'preview'],
};

export const GenerateGetQuoteNavigation = () => {
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleClickTab = (key) => {
    if (TAB_GROUPS.empty.includes(key)) {
      return;
    }
    if (TAB_GROUPS.scroll.includes(key)) {
      const element = document.getElementById(key);
      element.scrollIntoView();
    } else {
      document.location.href = key;
    }
  };

  const tabItems = useMemo(
    () => [
      {
        key: APP_ROUTES.SEARCH_QUOTE,
        label: t('translation:searchQuote.title'),
        children: <SearchQuotePage />,
      },
      {
        key: 'get_quote',
        label: 'Get Quote',
      },
      {
        key: 'QuoteCollboratorLogs',
        label: 'Collaborators',
      },
      {
        key: 'QuoteBiddingLogs',
        label: 'Bidding',
      },
      {
        key: 'bid_history',
        label: 'Bid History',
      },
      {
        key: 'preview',
        label: 'Preview',
      },
    ],
    [t],
  );

  return (
    <div style={{ height: '40px' }}>
      <Tabs
        className={`page-level-tab-container sub-level .tabs-margin-none ${isHBUser ? 'hb-tabs' : ''}`}
        activeKey="get_quote"
        onChange={(key) => handleClickTab(key)}
        items={tabItems}
      />
    </div>
  );
};

export default GenerateGetQuoteNavigation;
